import { useCallback } from 'react';
import { getWindow } from '../getWindow';
import { useExperimentFlag } from '../useExperimentFlag';
import { getCompactImageAlias, getGridImageAlias } from './getGridImageAlias';
import type { MDSAliases } from './getMdsUrl';

export function useIsGridImageOptimizerDisabled(): boolean {
    return Number(useExperimentFlag('disable_grid_image_optimizer')) === 1;
}

/** Возвращает оптимизированные алиасы для сеток и превью */
export function useGridImageOptimizer() {
    const disabled = useIsGridImageOptimizerDisabled();
    const dpr = getWindow()?.devicePixelRatio || 1;

    const getAlias = useCallback(
        (cardWidth?: number): MDSAliases | undefined => {
            if (disabled || cardWidth === undefined) {
                return undefined;
            }

            return getGridImageAlias(cardWidth, dpr);
        },
        [disabled, dpr],
    );

    const getCompactAlias = useCallback(
        (cardWidth: number): MDSAliases | undefined => {
            if (disabled) {
                return undefined;
            }

            return getCompactImageAlias(cardWidth, dpr);
        },
        [disabled, dpr],
    );

    return { disabled, getAlias, getCompactAlias };
}
